import variables from 'variables.module.scss';

export const Button = {
  defaultBorderColor: variables.primaryDarkColor,
  defaultBg: variables.whiteColor,
  defaultColor: variables.primaryDarkColor,
  contentFontSizeSM: 10,
  contentFontSize: 16,
  contentFontSizeLG: 18,
  paddingInlineSM: 20,
  paddingInline: 20,
  paddingInlineLG: 30,
};
